




































































































import { Currency } from "@/shared/models/currency";
import { Prepayment } from "@/shared/models/prepayment";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {},
})
export default class FinDocPrepaymentsModal extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @Prop() prepayments?: Prepayment[];
  @Prop({ default: false }) cancellation?: boolean; // storno fin docs
  @Prop({ default: false }) fromPaymentTable?: boolean;
  @Prop({ default: false }) fromDashboard?: boolean;
  @Prop() reservationId?: boolean;
  @Prop({ default: false }) selectAll?: boolean;

  @Prop({ default: true }) autoClose?: boolean;

  @Getter("codebooks/currencies") currencies?: Currency[];

  selectedPrepayments: Prepayment[] = [];
  loading = false;

  headers = [
    {
      text: "Booking date",
      value: "bookingDate",
      active: true,
      default: false,
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Period",
      value: "arrivalDate",
      active: true,
      default: false,
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Reservation holder name",
      value: "reservationHolderName",
      active: true,
      default: false,
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Dashboard.ReservationId",
      value: "reservationId",
      active: true,
      default: false,
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Dashboard.PrepaymentResAccUnitTypes",
      value: "accUnitType",
      active: true,
      default: false,
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Sales channel",
      value: "distributionChannel",
      active: true,
      default: false,
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Dashboard.PrepaymentDueDate",
      value: "prepaymentDueDate",
      active: true,
      default: false,
      sortable: false,
      exportHeaders: [],
    },
    {
      text: "Dashboard.PrepaymentAmount",
      value: "prepaymentAmount",
      active: true,
      default: false,
      sortable: false,
      class: "prepayment-amount",
      exportHeaders: [],
    },
  ];

  getCurrencyCode(currencyId: number) {
    return this.currencies?.find((x) => x.id == currencyId)?.isoCode;
  }

  @Watch("internalOpen")
  watchOpen(fresh: boolean) {
    if (fresh) {
      this.selectedPrepayments = [];
      if (this.selectAll && this.prepayments) {
        for (const item of this.prepayments) {
          this.selectedPrepayments.push(item);
        }
      }
    }
    if (!fresh) {
      this.loading = false;
    }
  }

  date(value: string) {
    return new Date(value);
  }

  get translatedHeaders() {
    return this.headers.map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  async setPrepaymentsStatus(createDownPayment = false) {
    this.loading = true;
    await this.axios
      .post("financialDocuments/SetPrepaymentsStatus", {
        prepaymentIds: this.selectedPrepayments.map((x) => x.id).join(","),
        isPaid: !this.cancellation,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t(
            !this.cancellation
              ? "PrepaymentMarkAsPaid.Success"
              : "PrepaymentMarkAsUnpaid.Success"
          ),
          timeout: 5000,
          localize: true,
        });
      })
      .finally(() => {
        this.$emit("saved");

        if (this.fromPaymentTable) {
          this.$emit("createOrUpdate");
        }

        if (this.fromDashboard && createDownPayment) {
          this.$emit(
            "createDownPayment",
            this.selectedPrepayments.map((x) => x.id)
          );
        }

        this.$emit("loadPrepayments");

        if (this.autoClose && !createDownPayment) {
          this.loading = false;
          this.close();
        }
      });
  }

  close() {
    this.internalOpen = false;
  }
}
